(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dm-collection-catalogue"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dm-collection-catalogue')) {
    customElements.define('dm-collection-catalogue', class extends HTMLElement {
      connectedCallback() {
        if (this.controller || document.querySelector('dm-collection-catalogue') !== this) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.refreshLinks();
        window.addEventListener('popstate', () => this.refreshLinks(), { signal });
        window.addEventListener('facet:update', (event) => this.protectFacetUrl(event), { capture: true, signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }

      preserveContext(url, current, view = this.dataset.templateView || current.searchParams.get('view')) {
        if (view) url.searchParams.set('view', view);
        for (const key of ['preview_theme_id', 'country', 'locale']) {
          if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
        }
        if (!url.searchParams.has('preview_theme_id')) {
          const theme = window.Shopify?.theme;
          const previewRole = theme?.role === 'unpublished' || theme?.role === 'development';
          if (previewRole && /^\d+$/.test(String(theme?.id ?? ''))) url.searchParams.set('preview_theme_id', String(theme.id));
        }
      }

      refreshLinks() {
        const current = new URL(location.href);
        const collectionPath = new URL(this.dataset.collectionUrl, location.origin).pathname.replace(/\/$/, '');
        const currentView = this.dataset.templateView || current.searchParams.get('view') || '';
        const previewRole = window.Shopify?.theme?.role === 'unpublished' || window.Shopify?.theme?.role === 'development';
        const managedView = previewRole || currentView.startsWith('dm-route-') || currentView === 'dm-lighting-focus';
        for (const link of this.querySelectorAll('[data-dm-catalogue-link][data-base-href]')) {
          const url = new URL(link.dataset.baseHref, location.origin);
          if (url.origin !== location.origin) continue;
          const sameCollection = url.pathname === collectionPath || url.pathname.startsWith(collectionPath + '/');
          const targetView = managedView ? link.dataset.targetView || '' : '';
          this.preserveContext(url, current, sameCollection ? currentView : targetView);
          const sort = current.searchParams.get('sort_by');
          if (sameCollection && sort) url.searchParams.set('sort_by', sort);
          link.href = url.toString();
        }
      }

      protectFacetUrl(event) {
        if (!(event.target instanceof Element)) return;
        if (!event.target.closest('.shopify-section--main-collection')) return;
        if (!event.detail?.url) return;
        let url;
        let collectionUrl;
        try {
          url = event.detail.url instanceof URL ? event.detail.url : new URL(event.detail.url, location.origin);
          collectionUrl = new URL(this.dataset.collectionUrl, location.origin);
        } catch {
          return;
        }
        if (url.origin !== location.origin) return;
        const collectionPath = collectionUrl.pathname.replace(/\/$/, '');
        if (url.pathname !== collectionPath && !url.pathname.startsWith(collectionPath + '/')) return;
        this.preserveContext(url, new URL(location.href));
        event.detail.url = url;
        queueMicrotask(() => { if (this.isConnected) this.refreshLinks(); });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-collection-quick-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dm-collection-quick-nav')) {
    customElements.define('dm-collection-quick-nav', class extends HTMLElement {
      connectedCallback() {
        if (this.controller || document.querySelector('dm-collection-quick-nav') !== this) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.refreshLinks();
        window.addEventListener('popstate', () => this.refreshLinks(), { signal });
        window.addEventListener('facet:update', (event) => this.protectFacetUrl(event), { capture: true, signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }

      preserveContext(url, current) {
        const view = this.dataset.templateView || current.searchParams.get('view');
        if (view) url.searchParams.set('view', view);
        for (const key of ['preview_theme_id', 'country', 'locale']) {
          if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
        }
        if (!url.searchParams.has('preview_theme_id')) {
          const theme = window.Shopify?.theme;
          const previewRole = theme?.role === 'unpublished' || theme?.role === 'development';
          if (previewRole && /^\d+$/.test(String(theme?.id ?? ''))) {
            url.searchParams.set('preview_theme_id', String(theme.id));
          }
        }
      }

      refreshLinks() {
        const current = new URL(location.href);
        for (const link of this.querySelectorAll('[data-dm-quick-link][data-base-href]')) {
          const url = new URL(link.dataset.baseHref, location.origin);
          this.preserveContext(url, current);
          const sort = current.searchParams.get('sort_by');
          if (sort) url.searchParams.set('sort_by', sort);
          link.href = url.toString();
        }
      }

      protectFacetUrl(event) {
        if (!(event.target instanceof Element)) return;
        if (!event.target.closest('.shopify-section--main-collection')) return;
        if (!event.detail?.url) return;
        let url;
        let collectionUrl;
        try {
          url = event.detail.url instanceof URL ? event.detail.url : new URL(event.detail.url, location.origin);
          collectionUrl = new URL(this.dataset.collectionUrl, location.origin);
        } catch {
          return;
        }
        if (url.origin !== location.origin) return;
        const collectionPath = collectionUrl.pathname.replace(/\/$/, '');
        if (url.pathname !== collectionPath && !url.pathname.startsWith(collectionPath + '/')) return;
        this.preserveContext(url, new URL(location.href));
        event.detail.url = url;
        queueMicrotask(() => {
          if (this.isConnected) this.refreshLinks();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-interactive-tank-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dm-interactive-tank-hero')) {
    customElements.define('dm-interactive-tank-hero', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.revision = 0;
        this.hotspots = [...this.querySelectorAll('[data-dm-hotspot]')];
        this.categories = [...this.querySelectorAll('[data-dm-category]')];
        this.panels = [...this.querySelectorAll('[data-dm-panel]')];
        this.overviewButton = this.querySelector('[data-dm-overview]');
        this.status = this.querySelector('[data-dm-status]');
        this.panelsRegion = this.querySelector('[data-dm-panels]');
        this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
        if (!this.panels.length) return;
        const options = { signal: this.abortController.signal };
        this.panels.forEach(panel => {
          panel.hidden = true;
          const close = panel.querySelector('[data-dm-close]');
          if (close) close.hidden = false;
        });
        [...this.hotspots, ...this.categories].forEach(control => {
          control.setAttribute('role', 'button');
          control.setAttribute('aria-expanded', 'false');
        });
        this.removeAttribute('data-active');
        this.style.setProperty('--dm-zoom', '1');
        this.overviewButton.hidden = true;
        this.dataset.enhanced = 'true';
        this.addEventListener('click', event => this.onClick(event), options);
        this.addEventListener('keydown', event => this.onKeydown(event), options);
        this.addEventListener('pointerover', event => this.onHighlight(event), options);
        this.addEventListener('pointerout', event => this.onUnhighlight(event), options);
        this.addEventListener('focusin', event => this.onHighlight(event), options);
        this.addEventListener('focusout', event => this.onUnhighlight(event), options);
        document.addEventListener('shopify:block:select', event => {
          const blockId = event.detail?.blockId;
          if (this.panels.some(panel => panel.dataset.dmPanel === blockId)) this.select(blockId, null, false);
        }, options);
        document.addEventListener('shopify:block:deselect', event => {
          if (event.detail?.blockId === this.dataset.active) this.select(null, null, false);
        }, options);
        this.motionQuery.addEventListener('change', () => {
          if (this.motionQuery.matches) this.transition?.skipTransition();
        }, options);
        window.addEventListener('hashchange', () => this.openHashTarget(), options);
        this.openHashTarget();
      }

      disconnectedCallback() {
        this.revision += 1;
        this.abortController?.abort();
        this.transition?.skipTransition();
      }

      controlFor(target) {
        if (!(target instanceof Element)) return null;
        const control = target.closest('[data-dm-hotspot], [data-dm-category]');
        return control?.closest('dm-interactive-tank-hero') === this ? control : null;
      }

      keyFor(control) {
        return control?.dataset.dmHotspot || control?.dataset.dmCategory;
      }

      openHashTarget() {
        const panel = this.panels.find(item => `#${item.id}` === window.location.hash);
        if (!panel) return;
        this.select(panel.dataset.dmPanel, this.categories.find(item => item.dataset.dmCategory === panel.dataset.dmPanel), false);
        panel.scrollIntoView({ block: 'nearest', behavior: 'instant' });
      }

      onClick(event) {
        if (!(event.target instanceof Element)) return;
        const control = this.controlFor(event.target);
        if (control) {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.select(this.keyFor(control), control, true);
          return;
        }
        if (event.target.closest('[data-dm-overview], [data-dm-close]')) this.select(null, null, true);
      }

      onKeydown(event) {
        if (event.key === 'Escape' && this.dataset.active) {
          event.preventDefault();
          this.select(null, null, true);
          return;
        }
        const control = this.controlFor(event.target);
        if (!control) return;
        if (event.key === ' ') {
          event.preventDefault();
          this.select(this.keyFor(control), control, true);
        }
        if (control.hasAttribute('data-dm-category')) {
          const index = this.categories.indexOf(control);
          const keys = {
            ArrowRight: (index + 1) % this.categories.length,
            ArrowLeft: (index + this.categories.length - 1) % this.categories.length,
            Home: 0,
            End: this.categories.length - 1
          };
          if (Object.hasOwn(keys, event.key)) {
            event.preventDefault();
            this.categories[keys[event.key]].focus();
          }
        }
      }

      onHighlight(event) {
        if (event.type === 'pointerover' && event.pointerType === 'touch') return;
        const control = this.controlFor(event.target);
        if (!control) return;
        const key = this.keyFor(control);
        [...this.hotspots, ...this.categories].forEach(item => item.toggleAttribute('data-highlight', this.keyFor(item) === key));
      }

      onUnhighlight(event) {
        const from = this.controlFor(event.target);
        if (!from || from.contains(event.relatedTarget)) return;
        const next = this.controlFor(event.relatedTarget) || this.controlFor(document.activeElement);
        const key = this.keyFor(next);
        [...this.hotspots, ...this.categories].forEach(item => item.toggleAttribute('data-highlight', Boolean(key) && this.keyFor(item) === key));
      }

      select(key, trigger, moveFocus) {
        const selectedPanel = this.panels.find(panel => panel.dataset.dmPanel === key);
        if (key && !selectedPanel) return;
        if (trigger) this.returnFocus = trigger;
        const revision = ++this.revision;
        this.transition?.skipTransition();
        const update = () => {
          if (!this.isConnected || revision !== this.revision) return;
          if (key) this.dataset.active = key;
          else this.removeAttribute('data-active');
          this.panels.forEach(panel => { panel.hidden = panel !== selectedPanel; });
          [...this.hotspots, ...this.categories].forEach(control => {
            control.setAttribute('aria-expanded', String(this.keyFor(control) === key));
            control.removeAttribute('data-highlight');
          });
          this.overviewButton.hidden = !key;
          const hotspot = this.hotspots.find(item => item.dataset.dmHotspot === key);
          this.style.setProperty('--dm-focus-x', `${Number(hotspot?.dataset.x ?? 50)}%`);
          this.style.setProperty('--dm-focus-y', `${Number(hotspot?.dataset.y ?? 50)}%`);
          this.style.setProperty('--dm-zoom', key ? String(Math.min(1.35, Math.max(1, Number(this.dataset.focusZoom) || 1))) : '1');
          this.status.textContent = selectedPanel?.dataset.selectedStatus || this.dataset.overviewStatus;
          if (moveFocus) {
            if (selectedPanel) {
              selectedPanel.querySelector('[data-dm-detail-title]')?.focus({ preventScroll: true });
              selectedPanel.scrollIntoView({ block: 'nearest', behavior: 'instant' });
            } else if (this.returnFocus?.isConnected) this.returnFocus.focus();
          }
        };
        if (!this.motionQuery.matches && typeof document.startViewTransition === 'function' && moveFocus && this.dataset.active) {
          this.panelsRegion.style.viewTransitionName = `dm-tank-${this.dataset.sectionId.replace(/[^a-zA-Z0-9_-]/g, '-')}`;
          const transition = document.startViewTransition(update);
          this.transition = transition;
          transition.ready.catch(() => {});
          transition.finished.catch(() => {}).finally(() => {
            if (this.transition === transition) {
              this.transition = null;
              this.panelsRegion.style.viewTransitionName = '';
            }
          });
        } else {
          update();
          if (selectedPanel && !this.motionQuery.matches) selectedPanel.animate([{ opacity: 0, translate: '0 6px' }, { opacity: 1, translate: '0 0' }], { duration: 240, easing: 'ease-out' });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-scenario-storage"] && !Shopify.designMode) return;
  try {
    
(() => {
  const prepare = (scope) => {
    scope.querySelectorAll('[data-dm-storage-navigation]').forEach((nav) => {
      const current = new URL(window.location.href);
      nav.querySelectorAll('[data-dm-storage-link]').forEach((link) => {
        const target = new URL(link.getAttribute('href'), window.location.origin);
        ['country', 'locale'].forEach((key) => {
          if (current.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key));
        });
        if (nav.dataset.previewRole === 'true' && nav.dataset.themeId) target.searchParams.set('preview_theme_id', nav.dataset.themeId);
        else target.searchParams.delete('preview_theme_id');
        link.setAttribute('href', target.pathname + target.search + target.hash);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => prepare(document), { once: true });
  else prepare(document);
  document.addEventListener('shopify:section:load', (event) => prepare(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-tank-explorer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dm-tank-explorer')) {
    customElements.define('dm-tank-explorer', class extends HTMLElement {
      connectedCallback() {
        this.listeners?.abort();
        this.listeners = new AbortController();
        const options = { signal: this.listeners.signal };
        this.camera = this.querySelector('[data-dmx-camera]');
        this.plane = this.querySelector('[data-dmx-image-plane]');
        this.viewport = this.querySelector('[data-dmx-viewport]');
        this.standardLayer = this.querySelector('[data-dmx-standard-media]');
        this.baseHost = this.querySelector('[data-dmx-base-host]');
        this.viewHost = this.querySelector('[data-dmx-view-host]');
        this.viewButtons = [...this.querySelectorAll('[data-dmx-view]')];
        this.appearanceControls = this.querySelector('[data-dmx-appearance-controls]');
        this.frontRatio ||= this.style.getPropertyValue('--dmx-ratio');
        this.finishHost = this.querySelector('[data-dmx-finish-host]');
        this.wheelHost = this.querySelector('[data-dmx-wheel-host]');
        this.lightHost = this.querySelector('[data-dmx-light-host]');
        this.previewHost = this.querySelector('[data-dmx-preview-host]');
        this.backButton = this.querySelector('[data-dmx-back]');
        this.status = this.querySelector('[data-dmx-status]');
        this.heroCopy = this.querySelector('[data-dmx-hero-copy]');
        this.version = this.dataset.defaultVersion === 'hybrid' ? 'hybrid' : 'petrol';
        this.versionButtons = [...this.querySelectorAll('[data-dmx-version]')];
        this.shopPanels = [...this.querySelectorAll('[data-dmx-shop-panel]')];
        this.shopEmpty = this.querySelector('[data-dmx-shop-empty]');
        this.shopHeading = this.querySelector('[data-dmx-shop-heading]');
        this.mainLink = this.querySelector('[data-dmx-main-link]');
        ['wheel-front', 'wheel-rear', 'light-left', 'light-right'].forEach(region => {
          ['x', 'y', 'rx', 'ry'].forEach(axis => {
            const property = `--dmx-${region}-${axis}`;
            const value = Number.parseFloat(this.style.getPropertyValue(property));
            if (Number.isFinite(value)) this.style.setProperty(property, `${Math.max(0, Math.min(axis.startsWith('r') ? 50 : 100, value))}%`);
          });
        });
        this.points = [...this.querySelectorAll('[data-dmx-hotspot]')];
        this.categories = [...this.querySelectorAll('[data-dmx-category]')];
        this.controls = [...this.points, ...this.categories];
        this.panels = [...this.querySelectorAll('[data-dmx-panel]')];
        this.variants = [...this.querySelectorAll('[data-dmx-variant]')];
        [...this.controls, ...this.variants].forEach(control => control.setAttribute('role', 'button'));
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.desktopLayout = matchMedia('(min-width: 990px)');
        this.revision = 0;
        this.previewRevision = 0;
        this.lookRevision = { finish: 0, wheels: 0 };
        this.lookOperations = {};
        this.pendingLooks = new Map();
        this.selected = { finish: null, wheels: null };
        this.previewKey = null;
        this.returnFocus = null;
        this.removeAttribute('data-error');
        this.removeAttribute('data-media-error');
        this.status.textContent = this.dataset.overviewStatus;
        this.announcement = 0;
        this.userInteractionRevision = 0;
        this.viewLoading = false;
        this.dataset.view = 'front';
        this.style.setProperty('--dmx-ratio', this.frontRatio);
        this.viewHost.replaceChildren();
        this.cameraTarget = 'matrix(1, 0, 0, 1, 0, 0)';
        this.camera.style.transform = this.cameraTarget;
        this.querySelectorAll('[data-dmx-standard], [data-dmx-group-reset], [data-dmx-versions], [data-dmx-views]').forEach(control => { control.hidden = false; });
        [this.finishHost, this.wheelHost, this.lightHost, this.previewHost].forEach(host => host.replaceChildren());
        this.standardLayer.hidden = false;
        this.setMode('overview', null);
        this.syncAppearance();
        this.syncView();
        this.dataset.enhanced = 'true';
        this.addEventListener('click', event => this.onClick(event), options);
        this.addEventListener('keydown', event => this.onKeydown(event), options);
        this.addEventListener('pointerover', event => this.onPreviewIntent(event), options);
        this.addEventListener('pointerout', event => this.onPreviewLeave(event), options);
        this.addEventListener('focusin', event => this.onPreviewIntent(event), options);
        this.addEventListener('focusout', event => this.onPreviewLeave(event), options);
        ['pointerdown', 'keydown', 'wheel', 'touchstart'].forEach(type => document.addEventListener(type, () => { this.userInteractionRevision += 1; }, { signal: this.listeners.signal, capture: true, passive: true }));
        this.motion.addEventListener('change', () => { if (this.motion.matches && this.cameraAnimation?.playState === 'running') this.cameraAnimation.finish(); this.stopPreview(); }, options);
        this.desktopLayout.addEventListener('change', () => { this.stopPreview(); this.heroCopy.inert = this.desktopLayout.matches && Boolean(this.dataset.active); }, options);
        this.resizeObserver = new ResizeObserver(() => {
          if (this.dataset.mode === 'detail' && !this.hasAttribute('data-media-error')) {
            this.freezeCamera();
            this.cameraTarget = this.targetTransform(this.dataset.active);
            this.camera.style.transform = this.cameraTarget;
          }
        });
        this.resizeObserver.observe(this.plane);
        document.addEventListener('shopify:block:select', event => {
          const key = event.detail?.blockId;
          if (this.panels.some(panel => panel.dataset.dmxPanel === key)) this.openDetail(key, null, false);
          else if (this.variants.some(control => control.dataset.dmxVariant === key)) this.showView('front').then(() => { if (this.isConnected && this.dataset.view === 'front') this.changeVariant(key, null); });
        }, options);
        document.addEventListener('shopify:block:deselect', event => { if (event.detail?.blockId === this.dataset.active) this.showOverview(false); }, options);
        window.addEventListener('hashchange', () => this.openHash(), options);
        this.openHash(true);
      }

      disconnectedCallback() {
        this.revision += 1;
        this.previewRevision += 1;
        this.listeners?.abort();
        this.operation?.abort();
        this.previewOperation?.abort();
        Object.values(this.lookOperations || {}).forEach(operation => operation.abort());
        this.cameraAnimation?.cancel();
        this.resizeObserver?.disconnect();
      }

      controlFor(target) {
        if (!(target instanceof Element)) return null;
        const control = target.closest('[data-dmx-hotspot], [data-dmx-category], [data-dmx-variant], [data-dmx-group-reset], [data-dmx-standard]');
        return control?.closest('dm-tank-explorer') === this ? control : null;
      }

      keyFor(control) { return control?.dataset.dmxHotspot || control?.dataset.dmxCategory; }

      onClick(event) {
        if (!(event.target instanceof Element)) return;
        if (event.target.closest('dm-tank-explorer') !== this) return;
        const versionButton = event.target.closest('[data-dmx-version]');
        if (versionButton) { this.changeVersion(versionButton.dataset.dmxVersion); return; }
        const viewButton = event.target.closest('[data-dmx-view]');
        if (viewButton) { this.showView(viewButton.dataset.dmxView); return; }
        const shopJump = event.target.closest('[data-dmx-shop-jump]');
        if (shopJump) {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.focusShop(shopJump.dataset.dmxShopJump);
          return;
        }
        const control = this.controlFor(event.target);
        if (control) {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (control.hasAttribute('data-dmx-variant')) this.changeVariant(control.dataset.dmxVariant, control);
          else if (control.hasAttribute('data-dmx-group-reset')) this.changeVariant(null, control, control.dataset.dmxGroupReset);
          else if (control.hasAttribute('data-dmx-standard')) this.resetLook();
          else this.openDetail(this.keyFor(control), control, true);
        } else if (event.target.closest('[data-dmx-back]')) this.showOverview(true);
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          if (this.dataset.mode !== 'overview') { event.preventDefault(); this.showOverview(true); }
          else this.stopPreview();
          return;
        }
        const control = this.controlFor(event.target);
        if (!control) return;
        if (event.key === ' ' && control.tagName === 'A') { event.preventDefault(); control.click(); }
        if (control.hasAttribute('data-dmx-category')) {
          const index = this.categories.indexOf(control);
          const keys = { ArrowRight: (index + 1) % this.categories.length, ArrowLeft: (index + this.categories.length - 1) % this.categories.length, Home: 0, End: this.categories.length - 1 };
          if (Object.hasOwn(keys, event.key)) { event.preventDefault(); this.categories[keys[event.key]].focus(); }
        }
      }

      onPreviewIntent(event) {
        if (event.type === 'pointerover' && event.pointerType !== 'mouse') return;
        const control = this.controlFor(event.target);
        if (!this.keyFor(control) || control.contains(event.relatedTarget) || this.suppressPreviewFocus) return;
        if (event.type === 'focusin' && !control.matches(':focus-visible')) return;
        if (this.dataset.mode === 'overview') this.preview(this.keyFor(control));
      }

      onPreviewLeave(event) {
        const control = this.controlFor(event.target);
        if (!this.keyFor(control) || control.contains(event.relatedTarget)) return;
        const next = this.controlFor(event.relatedTarget);
        if (this.keyFor(next)) return;
        if (event.type === 'pointerout' && this.previewKey) {
          const focused = this.controlFor(document.activeElement);
          if (this.keyFor(focused) && focused.matches(':focus-visible')) { this.preview(this.keyFor(focused)); return; }
        }
        this.stopPreview();
      }

      beginOperation() {
        this.operation?.abort();
        this.freezeCamera();
        this.viewLoading = false;
        this.operation = new AbortController();
        return { revision: ++this.revision, signal: this.operation.signal };
      }

      current(operation) { return this.isConnected && !operation.signal.aborted && operation.revision === this.revision; }

      announce(text, epoch) {
        if (epoch === undefined || epoch === this.announcement) this.status.textContent = text;
      }

      updateBusy() {
        if (this.viewLoading || this.pendingLooks.size > 0 || this.dataset.mode === 'entering' || this.dataset.mode === 'returning') this.setAttribute('aria-busy', 'true');
        else this.removeAttribute('aria-busy');
      }

      setMode(mode, key) {
        this.dataset.mode = mode;
        if (key) this.dataset.active = key; else this.removeAttribute('data-active');
        this.panels.forEach(panel => { panel.hidden = panel.dataset.dmxPanel !== key; });
        this.controls.forEach(control => control.setAttribute('aria-expanded', String(this.keyFor(control) === key)));
        this.backButton.hidden = mode === 'overview';
        this.heroCopy.inert = this.desktopLayout.matches && Boolean(key);
        this.syncShopping();
        this.updateBusy();
      }

      syncView() {
        const front = this.dataset.view === 'front';
        this.baseHost.hidden = !front;
        this.viewHost.hidden = front;
        this.viewButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.dmxView === this.dataset.view)));
        this.points.forEach(point => { point.hidden = point.dataset.showHotspot === 'false' || point.dataset.sceneView !== this.dataset.view; });
        if (this.appearanceControls) { this.appearanceControls.hidden = !front; this.appearanceControls.inert = !front; }
        const button = this.viewButtons.find(control => control.dataset.dmxView === this.dataset.view);
        if (button) this.viewport.setAttribute('aria-label', button.dataset.selectedStatus);
      }

      async activateView(view, operation) {
        if (!['front', 'side', 'rear', 'cabin'].includes(view)) throw new Error('Invalid view');
        if (view === this.dataset.view) {
          await this.readyImage(view === 'front' ? this.standardLayer.querySelector('img') : this.viewHost.querySelector('img'), operation.signal);
          return;
        }
        const image = view === 'front' ? await this.readyImage(this.standardLayer.querySelector('img'), operation.signal) : await this.loadImage('view', view, operation.signal);
        if (!this.current(operation)) return;
        this.cameraAnimation?.cancel();
        this.cameraTarget = 'matrix(1, 0, 0, 1, 0, 0)';
        this.camera.style.transform = this.cameraTarget;
        if (view !== 'front') {
          image.dataset.dmxViewMedia = view;
          this.viewHost.replaceChildren(image);
          this.viewHost.dataset.sceneView = view;
        }
        this.dataset.view = view;
        this.style.setProperty('--dmx-ratio', view === 'front' ? this.frontRatio : String(image.naturalWidth / image.naturalHeight));
        this.lightHost.replaceChildren();
        this.syncView();
      }

      async showView(view) {
        const operation = this.beginOperation();
        const epoch = ++this.announcement;
        const button = this.viewButtons.find(control => control.dataset.dmxView === view);
        this.stopPreview();
        this.removeAttribute('data-error');
        this.removeAttribute('data-media-error');
        this.lightHost.replaceChildren();
        this.viewLoading = true;
        this.setMode('overview', null);
        this.announce(button?.dataset.loadingStatus || this.dataset.overviewStatus, epoch);
        try {
          await this.activateView(view, operation);
          if (!this.current(operation)) return;
          await this.moveCamera(this.targetTransform(null), operation);
          if (!this.current(operation)) return;
          this.announce(button?.dataset.selectedStatus || this.dataset.overviewStatus, epoch);
        } catch {
          if (!this.current(operation)) return;
          this.setAttribute('data-error', '');
          this.announce(this.dataset.viewUnavailableStatus, epoch);
          await this.moveCamera(this.targetTransform(null), operation);
        } finally {
          if (this.current(operation)) { this.viewLoading = false; this.updateBusy(); }
        }
      }

      syncShopping() {
        this.dataset.version = this.version;
        this.versionButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.dmxVersion === this.version)));
        const active = ['entering', 'detail'].includes(this.dataset.mode) ? this.dataset.active : null;
        this.shopPanels.forEach(panel => { panel.hidden = panel.dataset.dmxShopPanel !== active || panel.dataset.dmxShopVersion !== this.version; });
        if (this.shopEmpty) this.shopEmpty.hidden = Boolean(active);
        if (this.mainLink) {
          const url = this.mainLink.dataset[`${this.version}Url`];
          this.mainLink.hidden = !url;
          if (url) this.mainLink.setAttribute('href', url); else this.mainLink.removeAttribute('href');
          const label = this.mainLink.dataset[`${this.version}Label`];
          if (label) this.mainLink.setAttribute('aria-label', label);
        }
        this.querySelectorAll('[data-dmx-shop-jump]').forEach(link => {
          const panel = this.shopPanels.find(item => item.dataset.dmxShopPanel === link.dataset.dmxShopJump && item.dataset.dmxShopVersion === this.version);
          if (panel) link.setAttribute('href', `#${panel.id}`);
        });
      }

      changeVersion(version, announce = true) {
        if (!['petrol', 'hybrid'].includes(version) || version === this.version) return;
        const focusHidden = this.shopPanels.some(panel => !panel.hidden && panel.contains(document.activeElement));
        this.version = version;
        this.removeAttribute('data-error');
        this.syncShopping();
        if (focusHidden) this.focusShop(this.dataset.active);
        if (announce) {
          const panel = this.shopPanels.find(item => !item.hidden);
          const button = this.versionButtons.find(item => item.dataset.dmxVersion === version);
          this.announce(panel?.dataset.shopStatus || button?.dataset.versionStatus || this.dataset.overviewStatus, ++this.announcement);
        }
      }

      focusShop(key) {
        const panel = this.shopPanels.find(item => item.dataset.dmxShopPanel === key && item.dataset.dmxShopVersion === this.version && !item.hidden);
        const heading = panel?.querySelector('[data-dmx-shop-panel-heading]') || this.shopHeading;
        if (!heading) return;
        heading.focus({ preventScroll: true });
        heading.scrollIntoView({ block: 'start', behavior: this.motion.matches ? 'instant' : 'smooth' });
      }

      template(kind, key) { return [...this.querySelectorAll(`template[data-dmx-${kind}-template]`)].find(template => template.getAttribute(`data-dmx-${kind}-template`) === key); }

      readyImage(image, signal) {
        if (!image) return Promise.reject(new Error('Missing image'));
        return new Promise((resolve, reject) => {
          let settled = false;
          const finish = error => {
            if (settled) return;
            settled = true;
            clearTimeout(timeout);
            image.removeEventListener('load', loaded);
            image.removeEventListener('error', failed);
            signal?.removeEventListener('abort', aborted);
            if (error) reject(error); else resolve(image);
          };
          const loaded = () => {
            if (!image.naturalWidth) { finish(new Error('Image unavailable')); return; }
            image.decode().then(() => finish(), () => finish(new Error('Image decode failed')));
          };
          const failed = () => finish(new Error('Image unavailable'));
          const aborted = () => finish(new DOMException('Aborted', 'AbortError'));
          const timeout = setTimeout(() => finish(new Error('Image load timed out')), 25000);
          image.addEventListener('load', loaded, { once: true });
          image.addEventListener('error', failed, { once: true });
          signal?.addEventListener('abort', aborted, { once: true });
          if (signal?.aborted) aborted();
          else if (image.complete) loaded();
        });
      }

      async loadImage(kind, key, signal) {
        const template = this.template(kind, key);
        if (!template) throw new Error('Missing configured image');
        const original = template.content.querySelector('img');
        if (!original) throw new Error('Missing configured image');
        const image = new Image();
        for (const attribute of original.attributes) {
          if (!['src', 'srcset', 'sizes', 'loading', 'decoding'].includes(attribute.name)) image.setAttribute(attribute.name, attribute.value);
        }
        image.loading = 'eager';
        image.decoding = 'async';
        if (original.hasAttribute('sizes')) image.sizes = original.getAttribute('sizes');
        if (original.hasAttribute('srcset')) image.srcset = original.getAttribute('srcset');
        image.src = original.getAttribute('src');
        try { await this.readyImage(image, signal); }
        catch (error) {
          if (signal?.aborted) { image.removeAttribute('srcset'); image.removeAttribute('src'); }
          throw error;
        }
        return image;
      }

      makeMasks(image, effect) {
        const fragment = document.createDocumentFragment();
        const names = effect === 'wheels' ? ['wheel-front', 'wheel-rear'] : ['light-left', 'light-right'];
        names.forEach(name => {
          const mask = document.createElement('div');
          mask.className = `dmx__mask dmx__mask--${name}`;
          mask.dataset.dmxMask = name;
          mask.append(image.cloneNode(true));
          fragment.append(mask);
        });
        return fragment;
      }

      freezeCamera() {
        if (!this.camera) return;
        const transform = getComputedStyle(this.camera).transform;
        this.cameraAnimation?.cancel();
        this.camera.style.transform = transform === 'none' ? 'matrix(1, 0, 0, 1, 0, 0)' : transform;
      }

      targetTransform(key) {
        if (!key) return 'matrix(1, 0, 0, 1, 0, 0)';
        const point = this.points.find(control => control.dataset.dmxHotspot === key);
        if (point?.dataset.showHotspot === 'false' || point?.dataset.sceneView !== this.dataset.view) return 'matrix(1, 0, 0, 1, 0, 0)';
        const scale = Math.min(this.dataset.view === 'front' ? 2.6 : 1.25, Math.max(1, Number(point?.dataset.zoom) || 1.8));
        const width = this.plane.clientWidth;
        const height = this.plane.clientHeight;
        const x = Math.min(100, Math.max(0, Number(point?.dataset.x) || 0)) / 100;
        const y = Math.min(100, Math.max(0, Number(point?.dataset.y) || 0)) / 100;
        return `matrix(${scale}, 0, 0, ${scale}, ${width * (.52 - x * scale)}, ${height * (.51 - y * scale)})`;
      }

      async moveCamera(target, operation) {
        const from = getComputedStyle(this.camera).transform;
        this.cameraTarget = target;
        this.camera.style.transform = target;
        if (this.motion.matches || operation.signal.aborted || from === target) return;
        if (!this.cameraAnimation) this.cameraAnimation = new Animation(new KeyframeEffect(this.camera, [], { duration: 600, easing: 'cubic-bezier(.4, 0, .2, 1)', fill: 'both' }), document.timeline);
        this.cameraAnimation.cancel();
        this.cameraAnimation.effect.setKeyframes([{ transform: from }, { transform: target }]);
        this.cameraAnimation.currentTime = 0;
        this.cameraAnimation.play();
        try { await this.cameraAnimation.finished; } catch { return; }
        if (this.current(operation)) { this.camera.style.transform = target; this.cameraAnimation.cancel(); }
      }

      async openDetail(key, trigger, moveFocus = true) {
        const panel = this.panels.find(item => item.dataset.dmxPanel === key);
        if (!panel) return;
        if (trigger) this.returnFocus = trigger;
        const operation = this.beginOperation();
        const epoch = ++this.announcement;
        this.removeAttribute('data-error');
        this.removeAttribute('data-media-error');
        this.stopPreview();
        this.setMode('entering', key);
        this.announce(panel.dataset.loadingStatus, epoch);
        this.loadConceptDetail(key, operation);
        if (moveFocus) {
          panel.querySelector('[data-dmx-detail-title]')?.focus({ preventScroll: true });
          if (!this.desktopLayout.matches) this.querySelector('.dmx__toolbar').scrollIntoView({ block: 'nearest', behavior: 'instant' });
        }
        try {
          await this.activateView(panel.dataset.sceneView || 'front', operation);
          if (!this.current(operation)) return;
          if (this.dataset.view === 'front') await Promise.allSettled([...this.pendingLooks.values()]);
          const point = this.points.find(control => control.dataset.dmxHotspot === key);
          let lightImage;
          if (this.dataset.view === 'front' && point?.dataset.effect === 'lights' && this.template('preview', key)) lightImage = await this.loadImage('preview', key, operation.signal);
          if (!this.current(operation)) return;
          this.lightHost.replaceChildren(lightImage ? this.makeMasks(lightImage, 'lights') : document.createDocumentFragment());
          await this.moveCamera(this.targetTransform(key), operation);
          if (!this.current(operation)) return;
          this.cameraTarget = this.targetTransform(key);
          this.camera.style.transform = this.cameraTarget;
          this.setMode('detail', key);
          this.announce(panel.dataset.selectedStatus, epoch);
        } catch {
          if (!this.current(operation)) return;
          this.cameraTarget = 'matrix(1, 0, 0, 1, 0, 0)';
          this.camera.style.transform = this.cameraTarget;
          this.lightHost.replaceChildren();
          this.setAttribute('data-media-error', '');
          this.setMode('detail', key);
          this.setAttribute('data-error', '');
          this.announce(this.dataset.detailMediaErrorStatus || this.dataset.errorStatus, ++this.announcement);
        }
      }

      async loadConceptDetail(key, operation) {
        const panel = this.panels.find(item => item.dataset.dmxPanel === key);
        const figure = panel?.querySelector('[data-dmx-concept-detail]');
        const host = figure?.querySelector('[data-dmx-detail-image-host]');
        if (!host || !this.template('detail-image', key)) return;
        try {
          const image = await this.loadImage('detail-image', key, operation.signal);
          if (!this.current(operation) || this.dataset.active !== key) return;
          image.dataset.dmxDetailImage = key;
          host.replaceChildren(image);
          figure.hidden = false;
        } catch { if (this.current(operation)) figure.hidden = true; }
      }

      async showOverview(restoreFocus = true) {
        const operation = this.beginOperation();
        const epoch = ++this.announcement;
        this.removeAttribute('data-error');
        this.removeAttribute('data-media-error');
        this.stopPreview();
        if (restoreFocus && this.shopPanels.some(panel => panel.contains(document.activeElement))) {
          const interimFocus = this.categories.find(control => control.dataset.dmxCategory === this.dataset.active) || this.backButton;
          interimFocus.focus({ preventScroll: true });
          interimFocus.scrollIntoView({ block: 'nearest', behavior: 'instant' });
        }
        this.setMode('returning', this.dataset.active);
        await this.moveCamera(this.targetTransform(null), operation);
        if (!this.current(operation)) return;
        this.lightHost.replaceChildren();
        this.setMode('overview', null);
        this.announce(this.dataset.overviewStatus, epoch);
        if (restoreFocus) this.restoreFocus();
      }

      restoreFocus() {
        if (!this.returnFocus?.isConnected) return;
        this.suppressPreviewFocus = true;
        this.returnFocus.focus({ preventScroll: true });
        this.returnFocus.scrollIntoView({ block: 'nearest', behavior: 'instant' });
        queueMicrotask(() => { this.suppressPreviewFocus = false; });
      }

      stopPreview() {
        this.previewRevision += 1;
        this.previewOperation?.abort();
        this.previewHost.replaceChildren();
        this.previewKey = null;
        this.controls.forEach(control => control.removeAttribute('data-highlight'));
      }

      async preview(key) {
        if (this.dataset.mode !== 'overview' || this.previewKey === key) return;
        this.stopPreview();
        this.previewKey = key;
        this.previewOperation = new AbortController();
        const signal = this.previewOperation.signal;
        const revision = this.previewRevision;
        this.controls.forEach(control => control.toggleAttribute('data-highlight', this.keyFor(control) === key));
        const point = this.points.find(control => control.dataset.dmxHotspot === key);
        const effect = point?.dataset.effect;
        if (this.dataset.view !== 'front' || point?.dataset.sceneView !== 'front' || !['lights', 'wheels'].includes(effect) || !this.template('preview', key)) return;
        try {
          const image = await this.loadImage('preview', key, signal);
          if (signal.aborted || revision !== this.previewRevision || this.dataset.mode !== 'overview' || this.dataset.view !== 'front') return;
          this.previewHost.replaceChildren(this.makeMasks(image, effect));
        } catch { if (!signal.aborted && revision === this.previewRevision) this.previewHost.replaceChildren(); }
      }

      syncAppearance() {
        ['finish', 'wheels'].forEach(group => {
          if (this.selected[group]) this.dataset[group] = this.selected[group]; else this.removeAttribute(`data-${group}`);
          this.variants.filter(control => control.dataset.group === group).forEach(control => control.setAttribute('aria-pressed', String(control.dataset.dmxVariant === this.selected[group])));
          this.querySelector(`[data-dmx-group-reset="${group}"]`)?.setAttribute('aria-pressed', String(!this.selected[group]));
        });
        const values = Object.values(this.selected).filter(Boolean);
        if (values.length) this.dataset.variant = values.join(' '); else this.removeAttribute('data-variant');
        const notes = values.map(key => this.variants.find(control => control.dataset.dmxVariant === key)?.dataset.note).filter(Boolean);
        const note = this.querySelector('[data-dmx-variant-note]');
        if (note) note.textContent = notes.join(' · ');
      }

      async changeVariant(key, trigger, groupOverride) {
        if (this.dataset.view !== 'front' || this.viewLoading) return;
        const control = this.variants.find(item => item.dataset.dmxVariant === key);
        const group = groupOverride || control?.dataset.group;
        if (!['finish', 'wheels'].includes(group) || (key && !this.template('variant', key))) return;
        this.lookOperations[group]?.abort();
        const controller = new AbortController();
        this.lookOperations[group] = controller;
        const revision = ++this.lookRevision[group];
        const epoch = ++this.announcement;
        this.removeAttribute('data-error');
        this.stopPreview();
        this.announce(control?.dataset.loadingStatus || this.dataset.resetStatus, epoch);
        const work = (async () => {
          try {
            const image = key ? await this.loadImage('variant', key, controller.signal) : null;
            if (!this.isConnected || controller.signal.aborted || revision !== this.lookRevision[group]) return;
            if (group === 'finish') {
              this.finishHost.replaceChildren(image || document.createDocumentFragment());
              this.standardLayer.hidden = Boolean(image);
            } else this.wheelHost.replaceChildren(image ? this.makeMasks(image, 'wheels') : document.createDocumentFragment());
            this.selected[group] = key || null;
            this.syncAppearance();
            this.announce(control?.dataset.selectedStatus || this.dataset.resetStatus, epoch);
          } catch {
            if (!controller.signal.aborted && revision === this.lookRevision[group]) { this.setAttribute('data-error', ''); this.announce(this.dataset.errorStatus, ++this.announcement); }
          }
        })();
        this.pendingLooks.set(group, work);
        this.updateBusy();
        await work;
        if (this.pendingLooks.get(group) === work) this.pendingLooks.delete(group);
        this.updateBusy();
      }

      resetLook() {
        Object.values(this.lookOperations).forEach(operation => operation.abort());
        this.lookRevision.finish += 1;
        this.lookRevision.wheels += 1;
        this.pendingLooks.clear();
        this.selected = { finish: null, wheels: null };
        this.finishHost.replaceChildren();
        this.wheelHost.replaceChildren();
        this.standardLayer.hidden = false;
        this.stopPreview();
        this.syncAppearance();
        this.updateBusy();
        this.removeAttribute('data-error');
        this.announce(this.dataset.resetStatus, ++this.announcement);
      }

      documentPaint(signal) {
        return new Promise((resolve, reject) => {
          let frame;
          const cleanup = () => { document.removeEventListener('DOMContentLoaded', paint); signal.removeEventListener('abort', abort); };
          const abort = () => { cancelAnimationFrame(frame); cleanup(); reject(new DOMException('Aborted', 'AbortError')); };
          const paint = () => { frame = requestAnimationFrame(() => { frame = requestAnimationFrame(() => { cleanup(); resolve(); }); }); };
          signal.addEventListener('abort', abort, { once: true });
          if (signal.aborted) abort();
          else if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint, { once: true, signal });
          else paint();
        });
      }

      openHash(initial = false) {
        let hash;
        try { hash = decodeURIComponent(location.hash.slice(1)); } catch { return; }
        const panel = this.panels.find(item => item.id === hash);
        if (panel) this.openDetail(panel.dataset.dmxPanel, this.categories.find(control => control.dataset.dmxCategory === panel.dataset.dmxPanel), false);
        const shopPanel = this.shopPanels.find(item => item.id === hash);
        if (shopPanel) {
          const key = shopPanel.dataset.dmxShopPanel;
          this.changeVersion(shopPanel.dataset.dmxShopVersion, false);
          const opening = this.openDetail(key, this.categories.find(control => control.dataset.dmxCategory === key), false);
          const revision = this.revision;
          const interactionRevision = this.userInteractionRevision;
          const signal = this.operation.signal;
          opening.then(async () => {
            if (initial) await this.documentPaint(signal);
            if (this.isConnected && !signal.aborted && this.revision === revision && this.userInteractionRevision === interactionRevision && this.version === shopPanel.dataset.dmxShopVersion && this.dataset.active === key && this.dataset.mode === 'detail') this.focusShop(key);
          }).catch(() => {});
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
